import React, {Component} from 'react';
import {connect} from 'react-redux';
import ArticlesList from "../../components/articles/articlesList";
import {
    changeArticlesListSettings, pageShiftArticles, receiveGetArticles, requestArticlesMessage, requestDeleteArticle,
    requestGetArticles,
    requestPatchArticle
} from "../../actions/articlesList";
import _ from 'lodash';
import {push} from "connected-react-router";
import SolicitorArticlesListHOC from "./solicitorArticlesListHOC";
import {requestGetAllArticlesSuggestions} from "../../actions/solicitorArticlesList";
import { _getFileFromBase64 } from "../../helpers/functions";
import { isAgent } from "../../helpers/functions";

// var download = require('in-browser-download');

class ArticlesListHOC extends Component {
    constructor(props){
        super(props);
        let askServer;
    }
    componentWillMount() {
        let parameters = this.getRequestParameters(this.props);
        this.askServer = setTimeout(()=>{this.props.requestGetArticles(parameters)},0);
        this.props.requestGetArticles(parameters);

        this.props.requestArticlesMessage();
    }

    componentWillReceiveProps = (nextProps) => {
        clearTimeout(this.askServer);
        if(this.props.articlesList.fetchingDocument && !nextProps.articlesList.fetchingDocument && nextProps.articlesList.failedToGetDocumentMsg === ''){
            _getFileFromBase64(nextProps.articlesList.documentToDownload);
        }
        if(
            this.props.articlesList.selectedView !== nextProps.articlesList.selectedView ||
            this.props.articlesList.selectedStatus !== nextProps.articlesList.selectedStatus ||
            this.props.articlesList.value !== nextProps.articlesList.value ||
            this.props.articlesList.page !== nextProps.articlesList.page) {
            const parameters = this.getRequestParameters(nextProps);
            if(
                this.props.articlesList.value !== nextProps.articlesList.value
                && nextProps.articlesList.value!==''
            ){
                parameters.offset = 0;
                parameters.limit = 5;
                this.askServer = setTimeout(()=>{this.props.getAllArticlesSuggestions(parameters)},150);
            }else {
                this.props.requestGetArticles(parameters);
            }
        }
    };

    getRequestParameters = (props) => {
        const calcOffset =parseInt(props.articlesList.selectedView)*(parseInt(props.articlesList.page) -1);
        const parameters = {
            limit: props.articlesList.selectedView,
            offset: calcOffset>0? calcOffset:0,
            published: props.articlesList.selectedStatus === '' || props.articlesList.selectedStatus==='published',
            unpublished: props.articlesList.selectedStatus === '' || props.articlesList.selectedStatus==='unpublished',
            search: props.articlesList.value !== ''? props.articlesList.value:null
        };
        return parameters;
    };

    // getFileFromBase64 = (documentToDownload) => {
    //     download(documentToDownload.encodedFile, documentToDownload.name, documentToDownload.fileType, 'base64');
    // };

    handleArticleCheckAndUnCheck = (checked, rowIndex, row) => {
        let currentSelectedRows = {};
        if (checked) {
            currentSelectedRows = { ...this.props.articlesList.selectedArticles, [rowIndex]: row }

        } else {
            currentSelectedRows = _.omit(this.props.articlesList.selectedArticles, [rowIndex]);
        }

        this.props.changeArticlesListSettings('selectedArticles', currentSelectedRows);
    };

    checkAll = (checked) => {
        let selectedRows = {};
        if (checked) {
            this.props.articlesList.articles.forEach((e, index) => {
                selectedRows = { ...selectedRows, [index]: e };
            });
        }

        this.props.changeArticlesListSettings('selectedArticles', selectedRows);
    };

    onSuggestionsFetchRequested = ({value}) => {
        this.props.changeArticlesListSettings('suggestions', this.getSuggestions(value))
    };

    getSuggestions = value => {
        return this.props.articlesList.suggestions
    };


    onSuggestionsClearRequested = () => {
        if (this.props.articlesList.value === '') {
            this.props.changeArticlesListSettings('suggestions', []);
        }
    };

    getSuggestionValue = suggestion => suggestion !== undefined ?(suggestion.title !== '' ? suggestion.title : (suggestion.authorName !== '' ? suggestion.authorName:'')):null;

    renderSuggestion = suggestion => (
        <div>
            {suggestion.title !== '' ? suggestion.title + ' | ' : ''}{suggestion.authorName !== '' ? suggestion.authorName + ' | ' : '' }
        </div>
    );

    onChange = (event, {newValue}) => {
        event.preventDefault();

        if (typeof newValue !== 'undefined') {
            this.props.changeArticlesListSettings('value', newValue);
            // if (newValue === '') {
            // 	this.props.changeArticlesListSettings('selectedSuggestions', []);
            // }
        }
    };

    onArticleSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
        if ( ( method === 'click' || (method === 'enter') )  && suggestion ) {
            let newValue = '';
            if(suggestion.title !==''){
                newValue = suggestion.title;
            }else if(suggestion.authorName !==''){
                newValue = suggestion.authorName;
            }
            let payload = {
                data: [suggestion],
                limit:0,
                offset:0,
                published:true,
                unpublished: false,
                totalRecords: 1
            };
            this.props.receiveGetArticles(payload);
            this.props.changeArticlesListSettings('value', newValue? newValue.toString(): '' );
            this.props.changeArticlesListSettings('suggestions', [suggestion]);

        }
    };

    handleAutoSuggestButton = (suggestion) => {
        const parameters = this.getRequestParameters(this.props);
        this.props.requestGetArticles(parameters);
    };

    handleEdit = () => {
        let selectedAction = this.props.articlesList.selectedAction;
        let selectedArticles = this.props.articlesList.selectedArticles;
        if (selectedAction === 'publish') {
            _.forEach(selectedArticles, e => {
                this.props.requestPatchArticle(
                    {
                        id: e.id,
                        live: true
                    }
                )
            });
        }
        else if (selectedAction === 'unpublish') {
            _.forEach(selectedArticles, e => {
                this.props.requestPatchArticle(
                    {
                        id: e.id,
                        live: false
                    }
                )
            });
        }
        else if (selectedAction === 'delete') {
            this.props.changeArticlesListSettings('deleteModal', true);
        }
    };

    handleDelete = () => {
        let selectedArticles = this.props.articlesList.selectedArticles;
        _.forEach(selectedArticles, article => {
            this.props.requestDeleteArticle(article.id)
        });
    };

    findArticles = () => {

        return this.props.articlesList.selectedArticles;
    };

    _handleArticleRowSelect = (evt, articleId) => {
        if(evt.button === 1){
            window.open('/articles/edit-article/' + articleId, '_blank');
        } else {
            this.props.push('/articles/edit-article/' + articleId)
        }
    };

    onReorder = (draggedItem, targetItem) => {
        this.props.requestPatchArticle({
            id: parseInt(draggedItem.id),
            weight: targetItem.weight
        });
    };

    render() {
        let value = this.props.articlesList.value;
        const inputProps = {
            placeholder: '',
            value,
            onChange: this.onChange
        };

        return (
            isAgent(this.props.userRoles)?
                <SolicitorArticlesListHOC
                />
                :
                <ArticlesList
                    onReorder={this.onReorder}
                    _handleArticleRowSelect={this._handleArticleRowSelect}
                    requestPatchArticle={this.props.requestPatchArticle}
                    handleDelete={this.handleDelete}
                    findArticles={this.findArticles}
                    handleEdit={this.handleEdit}
                    suggestions={this.props.articlesList.suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                    onSuggestionSelected={this.onArticleSuggestionSelected}
                    handleAutoSuggestButton={this.handleAutoSuggestButton}
                    push={this.props.push}
                    handleArticleCheckAndUnCheck={this.handleArticleCheckAndUnCheck}
                    pageShift={this.props.pageShift}
                    changeArticlesListSettings={this.props.changeArticlesListSettings}
                    articlesList={this.props.articlesList}
                    getArticles = {this.props.requestGetArticles}
                    checkAll={this.checkAll}
                />
        )
    }

}

const mapStateToProps = (state) => {
    return {
        articlesList: state.articlesList,
        userRoles: state.user.loggedInUser.roles
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeArticlesListSettings: (key, value) => {
            dispatch(changeArticlesListSettings(key, value))
        },
        pageShift: (direction, totalPaginationBoxes) => {
            dispatch(pageShiftArticles(direction, totalPaginationBoxes))
        },
        push: (url) => {
            dispatch(push(url))
        },
        requestGetArticles: (payload) => {
            dispatch(requestGetArticles(payload))
        },
        requestPatchArticle: (sendBody) => {
            dispatch(requestPatchArticle(sendBody))
        },
        requestDeleteArticle: (id) => {
            dispatch(requestDeleteArticle(id))
        },
        requestArticlesMessage: () => {
            dispatch(requestArticlesMessage())
        },
        getAllArticlesSuggestions: (payload) => {
            dispatch(requestGetAllArticlesSuggestions(payload))
        },
        receiveGetArticles: (payload) => {
            dispatch(receiveGetArticles(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticlesListHOC);
